// src/data/nurtureDefaults.js

export const initialStatus = {
  lastUpdated: new Date().toISOString().split("T")[0],
  regions: {
    India: {
      status: "Paused",
      reason: "Pending Coursera PII Compliance Review",
      nextAction: "Await final approval on integration integration",
      owner: "Luis",
    },
    Asia: {
      status: "Paused",
      reason: "Pending Coursera PII Compliance Review",
      nextAction: "Define country-specific routing",
      owner: "Luis",
    },
  },
};

export const segmentationOptions = {
  regions: ["India", "APAC (ex-India)"],
  personas: ["L&D Leader", "HR Director", "IT/Ops", "Individual Learner"],
  tiers: ["Enterprise (Tier 1)", "Mid-Market (Tier 2)"],
  stages: ["Awareness", "Consideration", "Decision"],
};

export const defaultStreams = [
  {
    id: 1,
    name: "IN_Enterprise_L&D_Awareness",
    region: "India",
    goal: "Education",
    cadence: "14-day",
    channels: ["Email", "LinkedIn"],
  },
];
